import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import RedirectPage from "@/pages/RedirectPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminManagers from "@/pages/admin/AdminManagers";
import AdminVacancies from "@/pages/admin/AdminVacancies";
import AdminFAQ from "@/pages/admin/AdminFAQ";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminRotation from "@/pages/admin/AdminRotation";
import AdminPixel from "@/pages/admin/AdminPixel";
import AdminTikTokPixel from "@/pages/admin/AdminTikTokPixel";
import AdminLogs from "@/pages/admin/AdminLogs";
import AdminQuiz from "@/pages/admin/AdminQuiz";
import AdminQuizResponses from "@/pages/admin/AdminQuizResponses";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/go/:type" element={<RedirectPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="managers" element={<AdminManagers />} />
            <Route path="vacancies" element={<AdminVacancies />} />
            <Route path="faq" element={<AdminFAQ />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="rotation" element={<AdminRotation />} />
            <Route path="pixel" element={<AdminPixel />} />
            <Route path="tiktok-pixel" element={<AdminTikTokPixel />} />
            <Route path="logs" element={<AdminLogs />} />
            <Route path="quiz" element={<AdminQuiz />} />
            <Route path="quiz-responses" element={<AdminQuizResponses />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
